module.exports = __webpack_public_path__ + "img/Dunaliella_salina.cda8f2be.jpg";